import { AxiosRequestConfig } from "axios";
import api from "../../../../lib/api";
import {
  IUpdateVendorPincodePayload,
  IVendorPincodeCreatePayload,
  IVendorPincodeExportParams,
  IVendorPincodeListSearch,
} from "../../../../types/master/vendorPincodeInterface";

const buildListParams = (data: IVendorPincodeListSearch) => {
  const params: Record<string, string | number> = {};

  if (data.search) {
    params.search = data.search;
  }
  if (data.vendor_id) {
    params.vendor_id = data.vendor_id;
  }

  return params;
};

export const getVendorPincodeListApi = async (data: IVendorPincodeListSearch) => {
  return await api.get(`/vendor-pincodes/${data.page}/${data?.pageLimit ?? 10}`, {
    params: buildListParams(data),
  });
};

export const createVendorPincodeApi = async (payload: IVendorPincodeCreatePayload) => {
  return await api.post("/vendor-pincodes/", payload);
};

export const getVendorPincodeByIdApi = async (id: number | string) => {
  return await api.get(`/vendor-pincodes/id/${id}`);
};

export const updateVendorPincodeByIdApi = async (
  id: number | string,
  payload: IUpdateVendorPincodePayload
) => {
  return await api.put(`/vendor-pincodes/id/${id}`, payload);
};

export const bulkCreateVendorPincodeApi = async (formData: FormData, config?: AxiosRequestConfig) => {
  return await api.post("/vendor-pincodes/bulk-create", formData, config);
};

export const bulkUpdateVendorPincodeApi = async (formData: FormData, config?: AxiosRequestConfig) => {
  return await api.put("/vendor-pincodes/bulk-update", formData, config);
};

export const getVendorPincodeExportApi = (params: IVendorPincodeExportParams) => {
  return api.get("/vendor-pincodes/export", {
    params: {
      vendor_id: params.vendor_id,
    },
    responseType: "blob",
  });
};

export const getVendorPincodeServiceabilityApi = async (pincode: string) => {
  return api.get("/vendor-pincodes/vendor-serviceability", {
    params: { pincode },
  });
};
